module.exports = function getResource(label, vars = []) {
    const resources = { standard: 'Standard', 'freeShipping': 'Beauty Insiders enjoy *FREE standard shipping* on all orders.' };
    return resources[label];
};
